var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tsinghua"}},[_c('div',{staticClass:"rectangle"},[_c('router-view',{attrs:{"redirectURI":_vm.redirectURI}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }